(function ($, Drupal, window, document) {

  'use strict';

  Drupal.behaviors.home = {
    attach: function (context, settings) {
      $("#top").headroom();
    }
  };

})(jQuery, Drupal, this, this.document);
